import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import AssetIcon from './Icon';
import ActionBarItemWrapper from '../../ActionBar/_partials/items/ActionBarItemWrapper';
import classnames from 'classnames';
import { formatDollars } from '../../utils/formatting';
import { Url } from '@wix/da-url';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from './Button.scss';
export var NonFunigbleButton = function (props) {
    var deviation = props.deviation, openBidModal = props.openBidModal, openManageModal = props.openManageModal, _a = props.deviation.extended, _b = _a === void 0 ? {} : _a, digitalAssetFull = _b.digitalAsset;
    var digitalAsset = deviation.digitalAsset;
    var digital_assets = useFlag('digital_assets');
    if (!digital_assets) {
        return null;
    }
    // Bail no asset
    if (!digitalAsset || !digitalAsset.asset || !digitalAssetFull) {
        return null;
    }
    var _c = digitalAsset.asset, isOwner = _c.isOwner, canOffer = _c.canOffer, canPurchase = _c.canPurchase, dollarPrice = _c.dollarPrice, subproductId = _c.subproductId;
    var offers = digitalAssetFull.offers;
    var hasOffer = false, madeOffer = false;
    if (offers) {
        hasOffer = !!offers.hasOffer;
        madeOffer = !!offers.madeOffer;
    }
    // Handle owner state
    if (isOwner) {
        return (React.createElement(ActionBarItemWrapper, { tooltip: hasOffer ? 'You have an offer!' : '', className: classnames(hasOffer && s['red-dot']) },
            React.createElement(GhostButton, { size: 'medium', variant: 'edit-purple', icon: AssetIcon, onClick: function () {
                    openManageModal && openManageModal(deviation);
                } }, "Manage Collectible")));
    }
    // This user made an offer
    if (madeOffer) {
        return (React.createElement(ActionBarItemWrapper, { tooltip: 'You made an offer to buy this item!' },
            React.createElement(GhostButton, { size: 'medium', variant: 'edit-purple', icon: AssetIcon, onClick: function () {
                    openManageModal && openManageModal(deviation);
                } }, "Manage Offer")));
    }
    // This user can make an offer
    if (canOffer) {
        return (React.createElement(ActionBarItemWrapper, { tooltip: 'You can offer to buy this collectible' },
            React.createElement(GhostButton, { size: 'medium', variant: 'main', icon: AssetIcon, onClick: function () {
                    openBidModal && openBidModal(deviation);
                } }, "Make an Offer")));
    }
    // The item is listed and the user can buy
    if (canPurchase) {
        return (React.createElement(ActionBarItemWrapper, { tooltip: "You can own this collectible deviation!" },
            React.createElement(GhostButton, { size: 'medium', variant: 'main', icon: AssetIcon, onClick: function () {
                    window.location.assign(Url.checkoutLink(subproductId || 0));
                } },
                "Own for ",
                formatDollars(dollarPrice))));
    }
    return null;
};
NonFunigbleButton.displayName = 'DasNonFungibleButton';
export default NonFunigbleButton;
//# sourceMappingURL=NonFungibleButton.js.map